export default __webpack_public_path__ + "./images/ma.f4c7a385.png";